import { SnGeoJSONLayer, SnInternalGeoJSONLayer } from '@lib/api/entities';
import { ISnFAIconConfig } from '@lib/geo/helpers';

export function genFaFonts(layer: SnGeoJSONLayer | SnInternalGeoJSONLayer): ISnFAIconConfig {
  const faFonts = {
    fat: {
      fontFamily: '"Font Awesome 6 Pro"',
      fontWeight: '100',
      fontStyle: 'thin',
    },
    fal: {
      fontFamily: '"Font Awesome 6 Pro"',
      fontWeight: '300',
      fontStyle: 'regular',
    },
    far: {
      fontFamily: '"Font Awesome 6 Pro"',
      fontWeight: '400',
      fontStyle: 'regular',
    },
    fas: {
      fontFamily: '"Font Awesome 6 Pro"',
      fontWeight: '900',
      fontStyle: 'bold',
    },
    fab: {
      fontFamily: '"Font Awesome 6 Brands"',
      fontWeight: '400',
      fontStyle: 'brands',
    },
    fad: {
      fontFamily: '"Font Awesome 6 Duotone"',
      fontWeight: '900',
      fontStyle: 'duotone',
    },
  };

  switch (layer.meta.fontSet) {
    case 'fat':
      return faFonts['fat'];
    case 'fal':
      return faFonts['fal'];
    case 'far':
      return faFonts['far'];
    case 'fas':
      return faFonts['fas'];
    case 'fab':
      return faFonts['fab'];
    case 'fad':
      return faFonts['fad'];
  }
}
